// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"index__wrapper___1dKus","box":"index__box___2WDcy","disabled":"index__disabled___2NF29"};